import { AppBar, Box, Button, Checkbox, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Divider, FormControl, FormControlLabel, FormHelperText, IconButton, Input, InputAdornment, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, makeStyles, Menu, MenuItem, Paper, Radio, RadioGroup, Select, Tab, Tabs, TextField, Tooltip, Typography, withStyles, FormGroup  } from "@material-ui/core";
import { Cancel, Check, CheckBox, CheckCircleOutline, Delete, PlayArrow, Refresh, Search, Error, KeyboardArrowUp, KeyboardArrowDown } from "@material-ui/icons";
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import { GlobalUseStyles } from "./GlobalUseStyles";
import Add from "@material-ui/icons/Add";
import { createCompare, executeCompare, updateCompare, getBatches, getBatchesFiltered, materialRevisionItemsExists, fetchCompareId, checkMaterialCharacteristics, TrackingPDMConnection, markStatusFlag } from "./RestService";
import { snackbar } from "../snackbarService";
import { useMsal } from "@azure/msal-react";
import { CheckMaterialsFound, ConvertedTimeString, GetArrayEmpty, GetEmpty, GetStringEmpty, LoadParameters } from './Common'
import config from "../config";
import Backdrop from '@material-ui/core/Backdrop';
import ModalPopup from './ModalPopup';
import AddIcon from '@material-ui/icons/Add';

const CustomRadio = withStyles({
  root: {
    color: "#0071B9",
    '&$checked': {
      color: "#0071B9",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const CustomRadioDisabled = withStyles({
  root: {
    color: "#ccc",
    '&$checked': {
      color: "#ccc",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue(value => value + 1);
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& > .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root": {
      flexWrap: "nowrap",
      overflowX: "hidden"  // or "hidden"
    }
  },
  item: {
    padding: "0 8px"
  },
  dvDiv: {
    display: "flex",
    flex: 1,
    //height: "32px",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "row",
    paddingTop: "0px",
    marginTop: "0px",
    marginLeft: theme.spacing(4),
  },
  testCasesButton: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(0),
    marginBottom: theme.spacing(1),
    alignSelf: "flex-end"
  },
  addCaseButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start"
  },
  addIcon: {

  },
  inputStyle: {
    height: "8px",
    //   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button, &[type=number]": {
    //     "-webkit-appearance": "none",
    //     display: "none",
    //     height: "29px",
    // }
  },
  multilineField: {
    width: "20%"
  },
  endAdornment: {
    paddingRight: 0
  },
  generateIdButton: {
    //marginRight: theme.spacing(2),
    marginLeft: "4px", //theme.spacing(1),
    width: "44px",
    minWidth: "44px",
    maxWidth: "44px",
    height: "29px",
    maxHeight: "29px",
    minHeight: "29px"
  },
  testInfoItem: {
    display: "flex",
    justifyContent: "center",
    marginRight: "4px"
  },
  textField: {
    minHeight: "24px",
    maxHeight: "32px",
    marginRight: "32px"
  },
  testInfoDesc: {
    flex: 1,
    //paddingRight: theme.spacing(1)
  },
  testInfoName: {
    flex: 1,
    marginRight: theme.spacing(2)
  },
  testInfoID: {
    marginRight: 0, //theme.spacing(1),
    marginLeft: theme.spacing(2),
    //flex: 1,
    width: "190px",
    backgroundColor: "#F0F0F0",
  },
  dialogPaper: {
    padding: "0px 0px",
    minWidth: "40%",
    maxWidth: "50%"
    //minHeight: "60vh",
    //maxHeight: "60vh"
  },
  topScrollPaper: {
    alignItems: 'flex-start',
  },
  topPaperScrollBody: {
    verticalAlign: 'top',
  },
  lockedTextField: {
    backgroundColor: "#F0F0F0"
  },
  helperTextOffset: {
    position: "absolute",
    left: "18px"
  },
  editableInput: {
    outline: "none",
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: "6px 8px",
    minHeight: 20,
    display: "inline-block",
    width: "90%",
    boxSizing: "border-box",
    transition: "0.2s",
    boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",

    "&:focus": {
      border: "1px solid #1976d2",
      backgroundColor: "#fff",
    },

    "&:hover": {
      border: "1px solid #ccc",
    },
  },

  editMode: {
    cursor: "text",
    backgroundColor: "#fff",
  },

  viewMode: {
    cursor: "default",
    backgroundColor: "transparent",
    border: "1px solid transparent",
  },
  errorInput: {
    border: "1px solid red !important",
  },
  
  errorText: {
    color: "red",
    fontSize: 12,
    marginTop: 2,
  },
  checkbox: {
    "&:hover": {
      backgroundColor: "rgba(0.15, 0.15, 0.7, 0.05)" //"#4D9CCE"
    },
    "&.Mui-checked:hover": {
      backgroundColor: "rgba(0.15, 0.15, 0.7, 0.05)", // "#80b8dc"
    }
  },
}))


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div

      hidden={value !== index}
      {...other}
    >
      {value === index && (
        <Box pt={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function EditBomCompare(props) {
  const classes = useStyles();
  const globalClasses = GlobalUseStyles();
  const [tabValue, setTabValue] = React.useState(0);
  const [allSubLevelsCheck, setAllSubLevelsCheck] = React.useState(false);

  const [addPDMCADDialog, setAddPDMCADDialog] = useState(false);
  const [addConfigurationDialog, setAddConfigurationDialog] = useState(false);
  const [addComparetoDialog, setAddComparetoDialog] = useState(false);

  const [levelsValue, setLevelsValue] = React.useState("allLevels");
  const [pdmCADValue, setPdmCADValue] = React.useState("useLatestPDM");
  const [compareName, setCompareName] = useState(props.selectedBomCompare == null ? "" : props.selectedBomCompare["name"]);
  const [compareDesc, setCompareDesc] = useState(props.selectedBomCompare == null ? "" : props.selectedBomCompare["description"]);
  const [pdmCADConfig, setPdmCADConfig] = React.useState("");
  const [testCaseSearch, setTestCaseSearch] = useState("");
  const [viewModeCase, setViewModeCase] = useState("");
  const [menuHeight, setMenuHeight] = useState("36px");
  const [windowHeight, setWindowHeight] = useState(500);
  const [submitTestCaseSearch, setSubmitTestCaseSearch] = useState("");
  const [masterStructureMaterials, setMasterStructureMaterials] = useState(props.selectedBomCompare == null ? [] : props.selectedBomCompare["configurations"])
  const [masterStructureCompareToMaterials, setMasterStructureCompareToMaterials] = useState(props.selectedBomCompare == null ? [] : props.selectedBomCompare["compareTo"])
  const [batches, setBatches] = useState(null);
  const [loadingBatches, setLoadingBatches] = useState(false);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [filteredConfigurations, setFilteredConfigurations] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const forceUpdate = useForceUpdate();

  const [selectedConfigurations, setSelectedConfigurations] = useState([]);
  const [configurationArray, setConfigurationArray] = useState([]);
  const [testCaseElAnchor, setTestCaseElAnchor] = useState(null);

  const [selectedComparetos, setSelectedComparetos] = useState([]);
  const [comparetoArray, setComparetoArray] = useState([]);

  const [showConfigRadio, setShowConfigRadio] = useState(false);
  const [latestConfig, setLatestConfig] = useState();

  const [customLevelValue, setCustomLevelValue] = React.useState(1);
  const [selectedBomCompare, setSelectedBomCompare] = useState(props.selectedBomCompare == null ? null : props.selectedBomCompare);

  const [lock, setLock] = useState(false);
  
  const [oneToOne, setOneToOne] = useState(props.selectedBomCompare == null ? false : "options" in props.selectedBomCompare ? "oneToOne" in props.selectedBomCompare["options"] ? props.selectedBomCompare["options"]["oneToOne"] : false : false);
  const [selectedStructures, setSelectedStructures] = useState([]);
  const [addMaterialDialog, setAddMaterialDialog] = useState(false);
  const [newMaterial, setNewMaterial] = useState("");
  const [currentMatDialog, setCurrentMatDialog] = useState(1);

  const { instance, accounts, inProgress } = useMsal();
  const history = useHistory();
  const [isChecking, setIsChecking] = useState(false);
  const [currentMaterial, setCurrentMaterial] = useState("");
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [invalidItemsList, setInvalidItemsList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [pdmUsername, setPdmUsername] = useState('');
  const [modalResult, setModalResult] = useState(null);
  const [modalResolve, setModalResolve] = useState(null);
  const modalResolveRef = useRef(null);
  const [asyncErrors, setAsyncErrors] = useState({});
  const validationId = useRef(0);

  const compareToOffset = 12;

  const openLoginModal = () => {
    return new Promise((resolve) => {
      setModalOpen(true);
      modalResolveRef.current = (result) => {
        setModalOpen(false);
        setModalResult(result);
        resolve(result);
      };
    });
  };

  const checkPDMLogin = async () => {
        let result = null;  
        let pdmLoginFailed = sessionStorage.getItem("pdmLoginFailed");
        if (pdmLoginFailed == "false")
        {
            return true;
        }

        result = await openLoginModal();

        console.log("RESULT: ", result);
        if (result && result.canceled && result.canceled == true)
        {
            snackbar.warning("PDM Login cancelled",300000);
            return false;
        }
        if (result && result.success && result.success == false)
        {
            let errorMsg = "Error during PDM login.";
            if (result.error && result.error != "")
            {
                errorMsg = result.error;
            }
            snackbar.warning(errorMsg,300000);
            return false;
        }
        if (result && result.success == true) {
            return true;
        }
        return false;
     };

  const handleTabChange = (event, newValue) => {
    setTestCaseSearch("");
    setTabValue(newValue);
  };

  const convertToUppercase = (e) => {
      e.preventDefault();
      setNewMaterial(e.target.value.toUpperCase());
  };

  const handleKeyPress = (event) => {
    if (event.key === ' ') {
        event.preventDefault();
    }
  };

  const convertSpaceToTrimmed = (e) => {
      e.preventDefault();
      setNewMaterial(e.target.value.replace(/^\s+|\s+$/gm, ''));
  };

  const closeTestOrderSearch = () => {
    setSubmitTestCaseSearch("");
    setTestCaseElAnchor(null)
  };

  const toggleStructure = (value) => {
  setSelectedStructures((prev) => {
    if (prev.includes(value)) {
      const newArr = prev.filter((v) => v !== value);
      // If removing would leave nothing, re-add the same value
      return newArr.length === 0 ? [value] : newArr;
    } else {
      return [...prev, value];
    }
  });
};

    const handleTestOrderSearch = (namefilter) => {
 
    setLoadingBatches(true);
    let tmpFilteredBatches = [];
    let tmpFilteredOrders = [];
    let fetchedBatches = [];
    let optedArrayList = [...configurationArray, ...comparetoArray];
    let tmpBatches = null;
    const uniqueOrderNames = new Set(); 
    const extractPrefix = (name) => name.slice(0, 10);
    const endFunction = async () => {
      if (tmpBatches["exception"]) {
        console.log(tmpBatches["exception"])
        setLoadingBatches(false);
      }
      else {
        for (const batch of tmpBatches) {
          if (batch["status"] == "Success") {
            tmpFilteredBatches.push(batch);
            await LoadParameters(instance, batch);
            let orders = batch["orders"];
            orders.forEach(order => {
            const orderName = order["name"];
            const orderPrefix = extractPrefix(orderName);
              if (tabValue == 1) {
                if(order["status"].toLowerCase() == "job completed") {
                  let orderNamecheck = order["name"]+"-"+batch["material"]+"/"+batch["materialRevision"];
                  if(optedArrayList.length === 0 || !(optedArrayList.includes(orderNamecheck))) {
                    tmpFilteredOrders.push(
                      {
                        "orderName": order["name"],
                        "material": batch["material"],
                        "materialRevision": batch["materialRevision"],
                        "lastRun": batch["lastRun"],
                        "description": order["description"]
                      });
                  }
                }
              }
              else if (tabValue == 2 && batch["executeArguments"] != null && order["status"].toLowerCase() == "job completed") {
                if ("levelOfScan" in batch["executeArguments"])
                {
                  let executeArguments = batch["executeArguments"];
                  if (executeArguments["levelOfScan"] == "deep_check"&& !uniqueOrderNames.has(orderPrefix)) {
                    uniqueOrderNames.add(orderPrefix);
                    tmpFilteredOrders.push({
                        "orderName": orderPrefix,
                        "material": batch["material"],
                        "materialRevision": batch["materialRevision"],
                        "lastRun": batch["lastRun"],
                        "description": order["description"]
                      });
                  }
                }
              }
            });
          }
        }
      }
 
      let finalFilteredOrders = tmpFilteredOrders
      .sort((a, b) => new Date(a["lastRun"]).valueOf() - new Date(b["lastRun"]).valueOf())
      .reverse()
      .filter(filteredName => {
        if (namefilter === "") return true;
        return (
          filteredName["orderName"].toLowerCase().includes(namefilter.toLowerCase()) ||
          filteredName["material"].toLowerCase().includes(namefilter.trim().toLowerCase()) ||
          (filteredName["material"].toLowerCase() + "/").includes(namefilter.toLowerCase()) ||
          (filteredName["material"].toLowerCase() + "/" + filteredName["materialRevision"].toLowerCase()).includes(namefilter.toLowerCase())
        );
      });
      setSubmitTestCaseSearch(namefilter);
      setFilteredOrders(tmpFilteredOrders);
      setFilteredBatches(tmpFilteredBatches);
      setLoadingBatches(false);
      forceUpdate();
    };
    if (batches == null) {
      let message = "";
      const CallfetchedBatches = async () => {
        fetchedBatches = await getBatches(instance)
      };
      CallfetchedBatches().catch((error) => { message += error.message + "\n" }).then(() => {
        if (message != "") {
          snackbar.error("Could not retrieve orders",300000);
          console.log("Fetching orders failed: ", message);
          setLoadingBatches(false);
        }
        else {
          setBatches(fetchedBatches);
          tmpBatches = fetchedBatches;
          endFunction();
         
        }
 
      });
 
    }
    else {
      tmpBatches = batches;
      endFunction();
    }
 
  };
  const handleSetConfigurationList = async (orderName) => {
    console.log("handleSetConfiguration", orderName);
    setTestCaseSearch(orderName);
    setSubmitTestCaseSearch("");
    setFilteredConfigurations([]);
   
    const uniqueConfigurations = new Set();
    let tmpFilteredConfigurations = [];
 
    for (const batch of filteredBatches) {
        // Check if the batch name matches the order name
        if (batch["name"] === orderName) {
            let confs = batch["configurationList"];
            confs.forEach(conf => {
                // Use Set to ensure unique configuration names
                if (conf.name.startsWith(orderName) && !uniqueConfigurations.has(conf.name)) {
                    uniqueConfigurations.add(conf.name);
                    tmpFilteredConfigurations.push(conf);
                }
            });
        }
    }
 
    if (tmpFilteredConfigurations.length > 0) {
        tmpFilteredConfigurations.sort((conf1, conf2) =>
            new Date(conf1["lastRun"]).valueOf() - new Date(conf2["lastRun"]).valueOf()
        ).reverse();
       
        //setLatestConfig(tmpFilteredConfigurations[0].name);
        setFilteredConfigurations(tmpFilteredConfigurations);
        const displayValue = tmpFilteredConfigurations.map(conf => conf.name).join("\n");
        setLatestConfig(displayValue);
        console.log(tmpFilteredConfigurations[0].name);
        console.log("displayValue",displayValue);
    }
};
  const handleSetConfiguration = async (orderName) => {
    console.log("handleSetConfiguration");
    setTestCaseSearch(orderName);
    setSubmitTestCaseSearch("");
    setFilteredConfigurations([]);
    let tmpFilteredConfigurations = [];
    for (const batch of filteredBatches) {
      await LoadParameters(instance, batch);
      let orders = batch["orders"];
      orders.forEach(order => {
        if (order["name"] == orderName) {
          let confs = batch["configurationList"];
          confs.forEach(conf => {
            if (conf.name.startsWith(orderName))
            tmpFilteredConfigurations.push(conf);
          });
        }
      });
    }
    if (tmpFilteredConfigurations.length > 0) {
      tmpFilteredConfigurations.sort((conf1, conf2) => new Date(conf1["lastRun"]).valueOf() - new Date(conf2["lastRun"]).valueOf()).reverse();
      setLatestConfig(tmpFilteredConfigurations[0].name);
      setFilteredConfigurations(tmpFilteredConfigurations);
      console.log(tmpFilteredConfigurations[0].name);
    }
  };

  const CallFetchCompareId = async () => {
    setLock(true);
    let message = "";
	const loginSuccess = await checkPDMLogin();
    if (loginSuccess == false)
    {
        return;
    }
    const result = await TrackingPDMConnection(instance);
    sessionStorage.setItem("trackPDMConnectionStatus", result);
    markStatusFlag();  
    if(result != "Success")     
    {
      snackbar.error("PDM is currently down.",300000);
      setLock(false);
      return false;
    }
    fetchCompareId(instance).catch((error) => { message += error.message + "\n" }).then((response) => {
      if (message != "") {
        snackbar.error(message,300000);
        setLock(false);
      }
      else {
        setCompareName(response);
        setLock(false);
      }
    });
  };

  const cleanText = (text = "") =>
    text.toUpperCase().replace(/\s+/g, " ").trim();
  
  const updateByIndex = (setter, index, value) => {
    setter((prev) => {
      if (!Array.isArray(prev)) return prev;
  
      const next = [...prev];
      next[index] = value ?? "";
      return next;
    });
  };

  const validateName = async (value, index) => {
    if (!value.includes("/")) {
      snackbar.error("Invalid format: expected 'Material / Material Revision",300000);
      setAsyncErrors((prev) => ({
        ...prev,
        [index]: true,
      }));
      return true;
    }    
    const [KoneMaterials, KoneMatRev = ""] = value.split("/");
    const id = ++validationId.current;
    setIsChecking(true);
    try {
      const statusMsg = await checkMaterialCharacteristics(
        instance,
        accounts[0].username,
        KoneMaterials,
        KoneMatRev
      );
      if (id !== validationId.current) return;
      let cstat = false;
      if (statusMsg === "NOT_FOUND") {
        if (KoneMaterials?.startsWith("KM")){
          snackbar.error(KoneMaterials + "/" + KoneMatRev + " do not exist in PDM, hence material cannot be added.",300000);
        } else {
          snackbar.error(KoneMaterials + "/" + KoneMatRev + " do not exist in PDM, hence configuration cannot be added.",300000);
        }
        cstat = true;
      }
      setAsyncErrors((prev) => ({
        ...prev,
        [index]: cstat,
      }));
      return cstat;
    } catch (err) {
      console.error("Error checking material:", err);
      if (id !== validationId.current) return;
      setAsyncErrors((prev) => ({
        ...prev,
        [index]: true,
      }));
      return true;
    } finally {
      if (id === validationId.current) {
        setIsChecking(false);
      }
    }
  };

  const EditableTypography = ({
    value,
    index,
    onChange,
    isViewMode,
    classes,
    globalClasses,
    required = false,
    validateAsync,
    asyncError,
  }) => {
    const ref = useRef(null);
  
    const isInvalid = required && (!value || value.trim().length === 0);
    const showError = isInvalid || asyncError;
  
    useEffect(() => {
      if (!ref.current) return;
  
      if (ref.current.textContent !== (value || "")) {
        ref.current.textContent = value || "";
      }
    }, [value]);
  
    const handleBlur = async () => {
      const text = ref.current?.textContent || "";
      const cleaned = cleanText(text);
  
      onChange(index, cleaned);
  
      if (cleaned && validateAsync) {
        await validateAsync(cleaned, index);
      }
    };
  
    const handlePaste = (e) => {
      e.preventDefault();
      const text = e.clipboardData.getData("text/plain");
      document.execCommand("insertText", false, cleanText(text));
    };
  
    return (
      <>
        <Typography
          ref={ref}
          contentEditable={!isViewMode}
          suppressContentEditableWarning
          className={`${classes.editableInput} ${
            isViewMode ? classes.viewMode : classes.editMode
          } ${isInvalid ? classes.errorInput : ""} ${
            globalClasses.smallFont
          }`}
          onBlur={handleBlur}
          onPaste={handlePaste}
        />
  
        {isInvalid && (
          <div className={classes.errorText}>Required</div>
        )}
  
        {!isInvalid && asyncError && (
          <div className={classes.errorText}>
            Please fix this
          </div>
        )}
      </>
    );
  };

  const handleRunClick = async (event, type) => {
    setLock(true);
    let message = "";
    let optionsObj = {};
    let configurations = [];
    let compareto = [];
    let order = "";

    let checkStr = "";
    let checkMaterials = [];
    let trimmedMaterials = [];
    let checkSuccess = true;
    let materialsFound = [];

    console.log("handleRunClick");

    const loginSuccess = await checkPDMLogin();
    if (loginSuccess == false)
    {
        return;
    }

    if (type == "Master Structure") {
      optionsObj["relationships"] = "cws_configure_all_relationships";
      optionsObj["oneToOne"] = oneToOne.toString();
      optionsObj["engineeringStructure"] = "false";
      optionsObj["deliveryStructure"] = "false";

      if (selectedStructures.includes("del")) {
        optionsObj["deliveryStructure"] = "true";
      }

      if (selectedStructures.includes("eng")) {
        optionsObj["engineeringStructure"] = "true";
      }
      
      let conMasterStructureMaterials = masterStructureMaterials;
      let conMasterStructureCompareToMaterials = masterStructureCompareToMaterials;
      conMasterStructureMaterials = conMasterStructureMaterials.filter(x => !/^\s*$/.test(x));
      conMasterStructureCompareToMaterials = conMasterStructureCompareToMaterials.filter(x => !/^\s*$/.test(x));
      configurations.push(conMasterStructureMaterials.join('\n'));
      compareto.push(conMasterStructureCompareToMaterials.join('\n'));
      trimmedMaterials = conMasterStructureMaterials.concat(conMasterStructureCompareToMaterials);
      checkStr = trimmedMaterials.join("||");

      let duplicateMaterials = conMasterStructureMaterials.filter(function(val) {
        return conMasterStructureCompareToMaterials.indexOf(val) != -1;
      });
      /*DA-1845 - removed check for duplicate materials in both lists
      if (oneToOne === false && typeof duplicateMaterials !== 'undefined' && duplicateMaterials.length > 0) {
        let errormsg = "Note: Same Material List for master structure comparison is not allowed.\n\n\n Please fix the duplicate material list for \n\n"+duplicateMaterials.join('\n');
        alert(errormsg);
        setLock(false);
        return false;
      }*/
    }
    else if (type == "Configuration Structure") {
      optionsObj["relationships"] = "cws_configure_all_relationships";
      optionsObj["oneToOne"] = oneToOne.toString(); 
       optionsObj["engineeringStructure"] = "false";
      optionsObj["deliveryStructure"] = "false";

      if (selectedStructures.includes("del")) {
        optionsObj["deliveryStructure"] = "true";
      }

      if (selectedStructures.includes("eng")) {
        optionsObj["engineeringStructure"] = "true";
      }  
      const configurationString = configurationArray.reduce((previous, current)=>previous + "\n" + current);
      const compareString = comparetoArray.reduce((previous, current)=>previous + "\n" + current);
      configurations.push(configurationString);
      compareto.push(compareString);
      console.log("configurations: ", configurations);
      console.log("comparetoArray: ", compareto);
    }
    else {
      optionsObj["oneToOne"] = oneToOne.toString();
      optionsObj["engineeringStructure"] = "true";
      optionsObj["deliveryStructure"] = "false";    
      if (pdmCADValue == "useLatestPDM") {
         const configArray = latestConfig.split("\n");
         configurations.push(...configArray);
         compareto.push(...configArray);
       }
      else {
        configurations.push(pdmCADConfig);
        compareto.push(pdmCADConfig);
      }
      optionsObj["pdmCADValue"] = pdmCADValue;
      optionsObj["order"] = testCaseSearch;
    }

    optionsObj["environment"] = config.environment;
    const saveAndExecute = () => {
      if (selectedBomCompare == null) {
        let compareData = null;
        let executeData = null;

        const createCompareCall = async () => {
          compareData = await createCompare(instance, type, compareName, compareDesc, configurations, compareto, optionsObj);
        };
        createCompareCall().catch((error) => { message += error.message + "\n" }).then(() => {
          console.log("CREATED: ", compareData);
          setSelectedBomCompare(compareData);
          const executeCompareCall = async () => {
            const result = await TrackingPDMConnection(instance);
            sessionStorage.setItem("trackPDMConnectionStatus", result);
            markStatusFlag();  
            if(result != "Success")     
            {
              snackbar.error("PDM is currently down.",300000);
              setLock(false);
              return false;
            }
            executeData = await executeCompare(instance, compareData["compareID"], configurations, compareto, optionsObj, accounts[0].username);
          };

          executeCompareCall().catch((error) => { message += error.message + "\n" }).then(() => {
            console.log("EXECUTED: ", executeData);
            if (message != "") {
              snackbar.error("Error: " + message,300000);
              setLock(false);
            }
            else {
              snackbar.success("BOM Compare execute started successfully.",300000);
              setLock(false);
              history.push("/bomcompare");
            }
          });

        });
      }
      else {
        let compareData = null;
        let executeData = null;
        const updateCompareCall = async () => {
          compareData = await updateCompare(instance, selectedBomCompare["compareID"], compareName, compareDesc, configurations, compareto, optionsObj);
        };
        updateCompareCall().catch((error) => { message += error.message + "\n" }).then(() => {
          console.log("UPDATED: ", compareData);
          setSelectedBomCompare(compareData);
          const executeCompareCall = async () => {
            const result = await TrackingPDMConnection(instance);
            sessionStorage.setItem("trackPDMConnectionStatus", result);
            markStatusFlag();
            if(result != "Success")     
            {
              snackbar.error("PDM is currently down.",300000);
              setLock(false);
              return false;
            }
            executeData = await executeCompare(instance, compareData["compareID"], configurations, compareto, optionsObj, accounts[0].username);
          };

          executeCompareCall().catch((error) => { message += error.message + "\n" }).then(() => {
            console.log("EXECUTED: ", executeData);
            if (message != "") {
              snackbar.error("Error: " + message,300000);
              setLock(false);
            }
            else {
              snackbar.success("BOM compare execute started successfully.",300000);
              setLock(false);
              history.push("/bomcompare");
            }
          });

        });
      }
    }

    const checkMaterialsCall = async () => {
      materialsFound = await materialRevisionItemsExists(instance, checkStr, accounts[0].username);
    };

    if (type == "Master Structure") {
      checkMaterialsCall().catch((error) => { message += error.message }).then(() => {
        if (message != "") {
          snackbar.error("Error during material check: " + message,300000);
          setLock(false);
        }
        else {
          var missingMats = CheckMaterialsFound(materialsFound, trimmedMaterials);
          if (missingMats != "") {
            snackbar.error("Could not find the following materials: " + missingMats,300000);
            setLock(false);
          }
          else {
            // Materials exist, proceed to create/update and run
            saveAndExecute();
          }
        }
      });
    }
    else {
      saveAndExecute();
    }

  };

  const GetRunDisabled = () => {
    let returnValue = (GetStringEmpty(compareName) || GetStringEmpty(compareDesc));

    // Master Structure
    if (tabValue == 0) {
      returnValue = returnValue || GetEmpty(masterStructureMaterials) || GetEmpty(masterStructureCompareToMaterials);
    }
    // Configuration Structure
    else if (tabValue == 1) {
      returnValue = returnValue || GetEmpty(configurationArray) || GetEmpty(comparetoArray);
    }
    // PDM CAD Comparison
    else if (tabValue == 2) {
      returnValue = returnValue || GetEmpty(searchValue);
    }

    return returnValue || lock;
  };

  const GetViewMode = () => {
    // let returnValue = selectedBomCompare != null;

    // return returnValue;
    return false;
  };

  useEffect(() => {
    if (props.selectedBomCompare != null) {
      console.log(props.selectedBomCompare);

      if (props.selectedBomCompare["compareType"] == "Master Structure") {
        setTabValue(0);
        setMasterStructureMaterials(selectedBomCompare["configurations"][0].split("\n"));
        setMasterStructureCompareToMaterials(selectedBomCompare["compareTo"][0].split("\n"));
        let selectedConfigOptions = selectedBomCompare["options"];
        let tmpSelected = [];
        if (selectedConfigOptions["engineeringStructure"] != null) {
          if (selectedConfigOptions["engineeringStructure"].toString() == "true")
          tmpSelected.push("eng");
        }
        if (selectedConfigOptions["deliveryStructure"] != null) {
          if (selectedConfigOptions["deliveryStructure"].toString() == "true"){
            tmpSelected.push("del");
          }
        }
        if (tmpSelected.length == 0) {
          tmpSelected.push("eng");
        }
        setSelectedStructures([...tmpSelected]);
      }
      else if (props.selectedBomCompare["compareType"] == "Configuration Structure") {
        setTabValue(1);
        setConfigurationArray([...selectedBomCompare["configurations"][0].split("\n")]);
        setComparetoArray([...selectedBomCompare["compareTo"][0].split("\n")]);
        let selectedConfigOptions = selectedBomCompare["options"];
        let tmpSelected = [];
        if (selectedConfigOptions["engineeringStructure"] != null) {
          if (selectedConfigOptions["engineeringStructure"].toString() == "true")
          tmpSelected.push("eng");
        }
        if (selectedConfigOptions["deliveryStructure"] != null) {
          if (selectedConfigOptions["deliveryStructure"].toString() == "true"){
            tmpSelected.push("del");
          }
        }
        if (tmpSelected.length == 0) {
          tmpSelected.push("eng");
        }
        setSelectedStructures([...tmpSelected]);
      }
      else if (props.selectedBomCompare["compareType"] == "PDM CAD Comparison") {
        setTabValue(2);
        //configurations.push(latestConfig);
        let selectedConfigOptions = selectedBomCompare["options"];
        if (selectedConfigOptions["order"] != null) {
          setViewModeCase(selectedConfigOptions["order"]);
          //setTestCaseSearch(selectedConfigOptions["order"]);
        }
        if (selectedConfigOptions["pdmCADValue"] != null) {
          setPdmCADValue(selectedConfigOptions["pdmCADValue"]);
        if (selectedConfigOptions["pdmCADValue"] === "useLatestPDM") 
        setLatestConfig(selectedBomCompare["configurations"].map(conf => conf.trim()).join("\n"));
        else
          setPdmCADConfig(selectedBomCompare["configurations"])
                }
                else
                setLatestConfig(selectedBomCompare["configurations"].map(conf => conf.trim()).join("\n"));
                if (selectedBomCompare["configurations"] && GetEmpty(selectedBomCompare["configurations"]) == false) {
                let newTestCaseSearchValue = "";
                for (let i = 0; i < selectedBomCompare["configurations"].length; i++) {
                let splitConf = selectedBomCompare["configurations"][i].split("-");
                if (splitConf.length > 1) {
                    newTestCaseSearchValue += splitConf[0] + "-" + splitConf[1] + "\n";
                }
              }
              setTestCaseSearch(newTestCaseSearchValue.trim()); 
              }
        setShowConfigRadio(true);
      }
    } else {
      if (selectedStructures.length == 0) {
          setSelectedStructures(["eng"]);
        }
    }
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
      setMenuHeight((windowHeight - windowHeight * 0.5 < 220 && windowHeight - windowHeight * 0.5 > 72)
        ?
        (windowHeight * 0.25).toString() + "px"
        :
        windowHeight - windowHeight * 0.5 > 72
          ?
          (windowHeight * 0.5).toString() + "px"
          :
          "36px");
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLevelsValueChange = (event) => {
    setLevelsValue(event.target.value);
  };

  const handlePDMCadValue = (event) => {
    setPdmCADValue(event.target.value);
  };


  const handleConfigClick = (value) => () => {
    console.log("handleConfigClick");
    const currentIndex = selectedConfigurations.indexOf(value);
    const newChecked = [...selectedConfigurations];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedConfigurations(newChecked);
    console.log("handleConfigClick", currentIndex);
    console.log(newChecked);

  };

  const handleComparetoClick = (value) => () => {
    console.log("handleComparetoClick");
    const currentIndex = selectedComparetos.indexOf(value);
    const newChecked = [...selectedComparetos];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedComparetos(newChecked);

    console.log("handleComparetoClick", currentIndex);
    console.log(newChecked);
  };

  const handleConfigClickPDMCAD = (confobj) => () => {
    console.log("handleConfigClickPDMCAD");
    setPdmCADConfig(confobj.name);
    setAddPDMCADDialog(false);
    console.log("PDM CAD configuration selected: ", confobj.name);
  };

  const handleDeleteConfigurationClick = (value) => () => {
    let newFinalConfigs = [...configurationArray];
    newFinalConfigs = newFinalConfigs.filter((e) => { return e !== value });
    setConfigurationArray(newFinalConfigs);
  };

  const handleDeleteConfigurationClick2 = (value) => () => {
    let newFinalConfigs = [...comparetoArray];
    newFinalConfigs = newFinalConfigs.filter((e) => { return e !== value });
    setComparetoArray(newFinalConfigs);
  };

  const handleConfigurationConfirmClick = async () => {
    let newFinalConfigs = [...configurationArray];
    let selectedConfigurationNames = [...selectedConfigurations.map((c) => { return c["name"] })];
    console.log(selectedConfigurationNames);

    const loginSuccess = await checkPDMLogin();
    if (loginSuccess == false)
    {
        return;
    }

    const [KoneConfigs, KoneConfigsRev = ""] = selectedConfigurationNames[0]?.split("/") || [];
    try {
      const statusMsg = await checkMaterialCharacteristics(
        instance,
        accounts[0].username,
        KoneConfigs,
        KoneConfigsRev
      );

      if (statusMsg === "NOT_FOUND") {
        snackbar.error(KoneConfigs + "/" + KoneConfigsRev + " do not exist in PDM, hence material cannot be added.",300000);
      } else {
        newFinalConfigs = newFinalConfigs.concat(selectedConfigurationNames);
      }
    } catch (err) {
      console.error("Error checking material:", err);
    }

    const uniqueConfigs = new Set(newFinalConfigs);
    const uniqueArray = Array.from(uniqueConfigs);
    setConfigurationArray(uniqueArray);
    setAddConfigurationDialog(false);
    setSelectedConfigurations([]);
    console.log("configurationArray:", configurationArray)
  };

  const handleComparetoConfirmClick = async () => {
    let newFinalConfigs = [...comparetoArray];
    let selectedConfigurationNames = [...selectedComparetos.map((c) => { return c["name"] })];
    console.log(selectedConfigurationNames);

    const [KoneConfigs, KoneConfigsRev = ""] = selectedConfigurationNames[0]?.split("/") || [];
    try {
      const statusMsg = await checkMaterialCharacteristics(
        instance,
        accounts[0].username,
        KoneConfigs,
        KoneConfigsRev
      );

      if (statusMsg === "NOT_FOUND") {
        snackbar.error(KoneConfigs + "/" + KoneConfigsRev + " do not exist in PDM, hence material cannot be added.",300000);
      } else {
        newFinalConfigs = newFinalConfigs.concat(selectedConfigurationNames);
      }
    } catch (err) {
      console.error("Error checking material:", err);
    }

    const uniqueConfigs = new Set(newFinalConfigs);
    const uniqueArray = Array.from(uniqueConfigs);
    setComparetoArray(uniqueArray);
    setAddComparetoDialog(false);
    setSelectedComparetos([]);
    console.log("comparetoArray:", comparetoArray)
  };

  const handleUpClick = (e, currentList) => {
    if (currentList == "configurations")
    {
        const index = configurationArray.indexOf(e);
        setConfigurationArray(moveElementUp(configurationArray, index));
    }
    else if(currentList == "compareto")
    {
      const index = comparetoArray.indexOf(e);
      setComparetoArray(moveElementUp(comparetoArray, index));
    }
    else if(currentList == "materials")
    {
      const index = masterStructureMaterials.indexOf(e);
      setMasterStructureMaterials(moveElementUp(masterStructureMaterials, index));
    }
    else if(currentList == "materials2")
    {
      const index = masterStructureCompareToMaterials.indexOf(e);
      setMasterStructureCompareToMaterials(moveElementUp(masterStructureCompareToMaterials, index));
    }
  }

  const handleDownClick = (e, currentList) => {
    if (currentList == "configurations")
      {
          const index = configurationArray.indexOf(e);
          setConfigurationArray(moveElementDown(configurationArray, index));
      }
      else if(currentList == "compareto")
      {
        const index = comparetoArray.indexOf(e);
        setComparetoArray(moveElementDown(comparetoArray, index));
      } 
      else if(currentList == "materials")
        {
          const index = masterStructureMaterials.indexOf(e);
          setMasterStructureMaterials(moveElementDown(masterStructureMaterials, index));
        }
        else if(currentList == "materials2")
        {
          const index = masterStructureCompareToMaterials.indexOf(e);
          setMasterStructureCompareToMaterials(moveElementDown(masterStructureCompareToMaterials, index));
        }
  }

  const moveElementUp = (array, index) => {
    const newArray = [...array]; // Create a shallow copy of the array
    if (index === 0) {
      const firstElement = newArray.shift(); // Remove the first element
      newArray.push(firstElement); // Add it to the end
    } else {
      [newArray[index], newArray[index - 1]] = [newArray[index - 1], newArray[index]]; // Swap
    }
    return newArray;
  };

  const moveElementDown = (array, index) => {
    const newArray = [...array]; // Create a shallow copy of the array
    if (index === newArray.length - 1) {
      const lastElement = newArray.pop(); // Remove the last element
      newArray.unshift(lastElement); // Add it to the beginning
    } else {
      [newArray[index], newArray[index + 1]] = [newArray[index + 1], newArray[index]]; // Swap
    }
    return newArray;
  };

  const handleOneToOneRadio = (e) => {
    setOneToOne(e.target.value === "true");
  }

  const handleAddMaterialConfirmClick = async () => {
    if (currentMatDialog == 1)
    {
      let newFinalMats = [...masterStructureMaterials];

      const [KoneMaterials, KoneMatRev = ""] = newMaterial.split("/");
      try {
        const statusMsg = await checkMaterialCharacteristics(
          instance,
          accounts[0].username,
          KoneMaterials,
          KoneMatRev
        );

        if (statusMsg === "NOT_FOUND") {
          if (KoneMaterials?.startsWith("KM")){
            snackbar.error(KoneMaterials + "/" + KoneMatRev + " do not exist in PDM, hence material cannot be added.",300000);
          } else {
            snackbar.error(KoneMaterials + "/" + KoneMatRev + " do not exist in PDM, hence configuration cannot be added.",300000);
          }
        } else {
          newFinalMats = newFinalMats.concat(newMaterial);
        }
      } catch (err) {
        console.error("Error checking material:", err);
      }
      

      const uniqueMats = new Set(newFinalMats);
      const uniqueArray = Array.from(uniqueMats);
      setMasterStructureMaterials(uniqueArray);
    }
    else if(currentMatDialog == 2)
    {
      let newFinalMats = [...masterStructureCompareToMaterials];

      const [KoneMaterials, KoneMatRev = ""] = newMaterial.split("/");
      try {
        const statusMsg = await checkMaterialCharacteristics(
          instance,
          accounts[0].username,
          KoneMaterials,
          KoneMatRev
        );

        if (statusMsg === "NOT_FOUND") {
          if (KoneMaterials?.startsWith("KM")){
            snackbar.error(KoneMaterials + "/" + KoneMatRev + " do not exist in PDM, hence material cannot be added.",300000);
          } else {
            snackbar.error(KoneMaterials + "/" + KoneMatRev + " do not exist in PDM, hence configuration cannot be added.",300000);
          }
        } else {
          newFinalMats = newFinalMats.concat(newMaterial);
        }
      } catch (err) {
        console.error("Error checking material:", err);
      }
      

      const uniqueMats = new Set(newFinalMats);
      const uniqueArray = Array.from(uniqueMats);
      setMasterStructureCompareToMaterials(uniqueArray);
    }
    
    setAddMaterialDialog(false);
  };

  const handleDeleteMaterialClick = (value) => () => {
    let newFinalMats = [...masterStructureMaterials];
    newFinalMats = newFinalMats.filter((e) => { return e !== value });
    setMasterStructureMaterials(newFinalMats);
  };

  const handleDeleteMaterial2Click = (value) => () => {
    let newFinalMats = [...masterStructureCompareToMaterials];
    newFinalMats = newFinalMats.filter((e) => { return e !== value });
    setMasterStructureCompareToMaterials(newFinalMats);
  };


  const convertMSMToUppercase = (e) => {
    e.preventDefault();
    setMasterStructureMaterials(e.target.value.toUpperCase());
  };

  const convertMSCTMToUppercase = (e) => {
    e.preventDefault();
    setMasterStructureCompareToMaterials(e.target.value.toUpperCase());
  };

  const handleImportFromFile2 = (event) => {
    const file = event.target.files[0];
    if (!file) {
      alert("Please select a file.");
      return;
    }
  
    if (file.type !== "text/plain") {
      alert("Please select a valid text file.");
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = async () => {
      setIsChecking(true); 

      const fileContent = reader.result;
      const lines = fileContent.split("\n").map(line => line.trim()).filter(Boolean);
  
      const validItems = [];
      const invalidItems = [];
  
      for (const line of lines) {
        let cleaned = line;
  
        if (line.startsWith("item:")) {
          cleaned = line.substring(5).trim();
        }
  
        const firstPart = cleaned.split(/\s+/)[0];
        if (!firstPart) continue;
  
        const [KoneMaterials, KoneMatRev = ""] = firstPart.split("/");

        setCurrentMaterial(`${KoneMaterials}/${KoneMatRev}`);
  
        try {
          const statusMsg = await checkMaterialCharacteristics(
            instance,
            accounts[0].username,
            KoneMaterials,
            KoneMatRev
          );
  
          if (statusMsg === "NOT_FOUND") {
            invalidItems.push(`${KoneMaterials}/${KoneMatRev}`);
          } else {
            // Skip if the material already exists in masterStructureMaterials
            const materialExists = masterStructureCompareToMaterials.some(existingMaterial => 
              existingMaterial === `${KoneMaterials}/${KoneMatRev}`
            );
            
            if (!materialExists) {
              validItems.push(`${KoneMaterials}/${KoneMatRev}`);
            } else {
              console.log(`Material already exists: ${KoneMaterials}/${KoneMatRev}`);
            }
          }
        } catch (err) {
          console.error("Error checking material:", err);
          invalidItems.push(`${KoneMaterials}/${KoneMatRev}`);
        }
      }
  
      if (validItems.length > 0) {
        setMasterStructureCompareToMaterials((prev) => [...prev, ...validItems]);
      }
  
      if (invalidItems.length > 0) {
        setInvalidItemsList(invalidItems);
        setOpenErrorDialog(true);

        300000
      }
      
      setIsChecking(false); 
      setCurrentMaterial("");
    };
  
    reader.onerror = () => {
      alert("Error reading the file.");
    };
  
    reader.readAsText(file);
  };
  

  const handleImportFromFile = (event) => {
    const file = event.target.files[0];
    if (!file) {
      alert("Please select a file.");
      return;
    }
  
    if (file.type !== "text/plain") {
      alert("Please select a valid text file.");
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = async () => {
      setIsChecking(true); 
      const fileContent = reader.result;
      const lines = fileContent.split("\n").map(line => line.trim()).filter(Boolean);
  
      const validItems = [];
      const invalidItems = [];
  
      for (const line of lines) {
        let cleaned = line;
  
        if (line.startsWith("item:")) {
          cleaned = line.substring(5).trim();
        }
  
        const firstPart = cleaned.split(/\s+/)[0];
        if (!firstPart) continue;
  
        const [KoneMaterials, KoneMatRev = ""] = firstPart.split("/");
        setCurrentMaterial(`${KoneMaterials}/${KoneMatRev}`);
  
        try {
          const statusMsg = await checkMaterialCharacteristics(
            instance,
            accounts[0].username,
            KoneMaterials,
            KoneMatRev
          );
  
          if (statusMsg === "NOT_FOUND") {
            invalidItems.push(`${KoneMaterials}/${KoneMatRev}`);
          } else {
            // Skip if the material already exists in masterStructureMaterials
            const materialExists = masterStructureMaterials.some(existingMaterial => 
              existingMaterial === `${KoneMaterials}/${KoneMatRev}`
            );
            
            if (!materialExists) {
              validItems.push(`${KoneMaterials}/${KoneMatRev}`);
            } else {
              console.log(`Material already exists: ${KoneMaterials}/${KoneMatRev}`);
            }
          }
        } catch (err) {
          console.error("Error checking material:", err);
          invalidItems.push(`${KoneMaterials}/${KoneMatRev}`);
        }
      }
  
      if (validItems.length > 0) {
        setMasterStructureMaterials((prev) => [...prev, ...validItems]);
      }
  
      if (invalidItems.length > 0) {
        setInvalidItemsList(invalidItems);
        setOpenErrorDialog(true);

        300000
      }

      setIsChecking(false); 
      setCurrentMaterial("");
    };
  
    reader.onerror = () => {
      alert("Error reading the file.");
    };
  
    reader.readAsText(file);
  };
  
    
 return (
    <>
      <Paper>

        <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary"
          textColor="primary" >
          <Tab label="BOM Compare" disabled={selectedBomCompare == null ? false : selectedBomCompare["type"] == "Master Structure" ? false : true} />
          <Tab label="Configuration Structure" disabled={selectedBomCompare == null ? false : selectedBomCompare["type"] == "Configuration Structure" ? false : true} />
          {/* <Tab label="PDM CAD Comparison" disabled={selectedBomCompare == null ? false : selectedBomCompare["type"] == "PDM CAD Comparison" ? false : true} /> */}
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <Paper style={{ maxHeight: "70vh", paddingBottom: "22px" }}>

          <div className={classes.dvDiv} style={{ paddingTop: "4px", paddingBottom: "4px" }}>
            <Typography className={classes.testInfoItem}>Name:</Typography>
            {/* <Tooltip title={testName} TransitionComponent={({ children }) => children}>
                        <TextField id="outlined-basic" defaultValue={testName} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoName)} />
                    </Tooltip> */}

            <Tooltip title={""} TransitionComponent={({ children }) => children}>
              <TextField disabled error={GetStringEmpty(compareName)} helperText={GetStringEmpty(compareName) ? "Missing BOM Compare name" : ""} FormHelperTextProps={{
                className: globalClasses.helperText
              }} InputProps={{ classes: { input: classes.inputStyle } }} id="outlined-basic" value={compareName} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoID)} onChange={(e) => { setCompareName(e.target.value); }} />
            </Tooltip>

            <Tooltip title={"Generate ID"}>
              <span>

                <Button disabled={GetViewMode()} size="small" className={clsx(classes.generateIdButton, globalClasses.blueButton, GetViewMode() && globalClasses.disabledButton)} onClick={() => {
                  if (compareName == "") {
                    CallFetchCompareId();
                  }
                }} >

                  <Refresh />
                </Button>
              </span>
            </Tooltip>

            <Typography className={classes.testInfoItem} style={{ paddingLeft: "14px" }}>Description:</Typography>
            <Tooltip title={""} TransitionComponent={({ children }) => children}>
              <TextField disabled={GetViewMode()} error={GetStringEmpty(compareDesc)} helperText={GetStringEmpty(compareDesc) ? "Missing BOM Compare description" : ""} FormHelperTextProps={{
                className: clsx(globalClasses.helperText, classes.helperTextOffset)
              }} id="outlined-basic" InputProps={{ classes: { input: classes.inputStyle } }} value={compareDesc} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoDesc)} onChange={(e) => { setCompareDesc(e.target.value); }} />
            </Tooltip>
            {/* <Typography>{"Run BOM Comparison for Master structure"}</Typography> */}
            <Tooltip title={"Run BOM Comparison"} TransitionComponent={({ children }) => children}>
              <span>
                <IconButton disabled={GetRunDisabled() || GetViewMode()} style={{ marginLeft: "auto", marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton, (GetRunDisabled() || GetViewMode()) && globalClasses.disabledButton)} onClick={(e) => {
                  handleRunClick(e, "Master Structure");
                }}>
                  <PlayArrow />
                </IconButton>
              </span>
            </Tooltip>
          </div>

          <div className={classes.dvDiv} style={{ paddingTop: "8px"}}>
            <Typography style={{ fontWeight: "bold" }}>{"Select Structure:"}</Typography>
          </div>
          <div className={classes.dvDiv} style={{ paddingTop: "4px", alignItems: "flex-start", position: "relative" }}>
          <FormGroup row aria-label="structure" style={{ gap: 8 }}>
            <FormControlLabel
              style={{ marginLeft: 0 }}
              control={
                GetViewMode()
                  ? <CustomRadioDisabled
                      style={{ marginRight: "8px" }}
                      checked={selectedStructures.includes("eng")}
                      onClick={() => toggleStructure("eng")}
                      className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)}
                    />
                  : <CustomRadio
                      style={{ marginRight: "8px" }}
                      checked={selectedStructures.includes("eng")}
                      onClick={() => toggleStructure("eng")}
                      className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)}
                    />
              }
              label="Engineering Structure"
              labelPlacement="end"
              disabled={GetViewMode()}
            />

            <FormControlLabel
              style={{ marginLeft: "8px" }}
              control={
                GetViewMode()
                  ? <CustomRadioDisabled
                      style={{ marginRight: "8px" }}
                      checked={selectedStructures.includes("del")}
                      onClick={() => toggleStructure("del")}
                      className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)}
                    />
                  : <CustomRadio
                      style={{ marginRight: "8px" }}
                      checked={selectedStructures.includes("del")}
                      onClick={() => toggleStructure("del")}
                      className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)}
                    />
              }
              label="Delivery Structure"
              labelPlacement="end"
              disabled={GetViewMode()}
            />
          </FormGroup>
          </div>
          
          <div className={classes.dvDiv} style={{ paddingTop: "4px"}}>
            <Typography style={{ fontWeight: "bold" }}>{"Select Method:"}</Typography>
          </div>
          <div className={classes.dvDiv} style={{ paddingTop: "4px", paddingBottom: "8px", alignItems: "flex-start", position: "relative" }}>
          <RadioGroup row aria-label="onetoone" name="onetoone" value={oneToOne.toString()} onChange={handleOneToOneRadio}>
                    <FormControlLabel
                      style={{ marginLeft: 0 }}
                      value="false"
                      control={
                        GetViewMode() ?
                          <CustomRadioDisabled style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />
                          :
                          <CustomRadio style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />}
                      label="ALL to ALL"
                      labelPlacement="end"
                      disabled={GetViewMode()}
                    />
                    <FormControlLabel
                      style={{ marginLeft: "86px" }}
                      value="true"
                      control={
                        GetViewMode() ?
                          <CustomRadioDisabled style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />
                          :
                          <CustomRadio style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />}
                      label="ONE to ONE"
                      labelPlacement="end"
                      disabled={GetViewMode()}
                    />
                  </RadioGroup>
          </div>

          <div className={classes.dvDiv} style={{ paddingTop: "26px", alignItems: "flex-start", position: "relative"  }}>

            <Typography style={{ position: "absolute", top: 0, left: 0 }}>{"Materials:"}</Typography>

            {/* Spinner Overlay */}
            {isChecking && (
              <Backdrop open={true} style={{ zIndex: 9999, color: '#fff' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress color="inherit" />
                <div style={{ marginLeft: 16 }}>
                  <span style={{ display: "block", marginTop: 8 }}>
                    Checking for enlisted Materials if available in PDM or not...
                  </span>
                  {currentMaterial && (
                    <span style={{ display: "block", marginTop: 8, fontWeight: "bold" }}>
                      {currentMaterial}
                    </span>
                  )}
                </div>
              </div>
            </Backdrop>
            
            )}
            {/* New "+ Import from file" buttons */}
            <div style={{ position: "absolute", top: 0, left: 80 }}>
                <Button 
                  disabled={GetViewMode()}
                  variant="contained"
                  className={clsx(classes.testCasesButton, globalClasses.blueButton, classes.addCaseButton)}
                  style={{
                    left: 120,
                    padding:"2px",
                    paddingLeft:"12px",
                    paddingRight:"12px",
                    }}
   onClick={() => document.getElementById("file-input").click()} 
                >
                  <AddIcon className={classes.addIcon} /> Import from file
                </Button>
                {/* Hidden File Input */}
                <input
                  id="file-input"
                  type="file"
                  style={{ display: "none" }}  // Hide the file input
                  accept=".txt"
                  onChange={handleImportFromFile}  // Trigger the function when a file is selected
                />
              </div>
              <Dialog
                open={openErrorDialog}
                onClose={() => setOpenErrorDialog(false)}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle style={{ color: '#f44336' }}>
                  Materials Not Found in PDM
                </DialogTitle>
                <DialogContent dividers style={{ maxHeight: 400, overflowY: "auto" }}>
                  <Typography variant="body2" gutterBottom>
                    The following materials were not found in PDM and were not added:
                  </Typography>
                  <List dense>
                    {invalidItemsList.map((item, index) => (
                      <ListItem key={index}>
                        <Typography variant="body2" style={{ wordBreak: "break-all" }}>
                          {item}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenErrorDialog(false)} color="primary">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>

            <Tooltip title={"Add material"} PopperProps={{ style: { marginLeft: 665 } }} TransitionComponent={({ children }) => children}>
              <span>

                <IconButton disabled={GetViewMode()} style={{ position: "absolute", top: 0, left: 385, width: 24, height: 24, borderRadius: 4 }} className={clsx(classes.generateIdButton, globalClasses.blueButton)} onClick={() => {
                  setCurrentMatDialog(1);
                  setAddMaterialDialog(true);
                  setNewMaterial("");
                }}>
                  <Add />
                </IconButton>
              </span>
            </Tooltip>
            <List style={{ minWidth: "430px", marginTop: "1%", marginBottom: "12px", minHeight: '10px', maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin', boxSizing: "content-box" }} className={clsx("listFix",!GetEmpty(masterStructureMaterials) && globalClasses.addBorder, (GetEmpty(masterStructureMaterials) && !GetViewMode()) && globalClasses.errorBorder)}>
              {masterStructureMaterials.map((e, index) => {
                const isMatch = masterStructureCompareToMaterials.includes(e);

                return (
                  <React.Fragment key={"Materials" + e + index}>
                    <ListItem classes={{ root: classes.item }} style={{ backgroundColor: isMatch ? "#ffcccc" : "transparent" }}>
                    <IconButton disabled={GetViewMode()} aria-label="Up" className={globalClasses.customButton} onClick={() => handleUpClick(e, "materials")}>
                          <KeyboardArrowUp />
                        </IconButton>
                    <IconButton disabled={GetViewMode()} aria-label="Down" className={globalClasses.customButton} onClick={() => handleDownClick(e, "materials")}>
                          <KeyboardArrowDown />
                        </IconButton>
                      <ListItemText
                        primary={<EditableTypography
                          value={masterStructureMaterials[index]}
                          index={index}
                          isViewMode={GetViewMode()}
                          classes={classes}
                          globalClasses={globalClasses}
                          required={true}
                          onChange={(i, val) =>
                            updateByIndex(setMasterStructureMaterials, i, val)
                          }
                          asyncError={asyncErrors[`masterStructureMaterials-${index}`] || false}
                          validateAsync={(val) => validateName(val, `masterStructureMaterials-${index}`)}
                        />}
                      />
                      <ListItemSecondaryAction>
                        <IconButton disabled={GetViewMode()} edge="end" aria-label="delete" className={globalClasses.customButton} onClick={handleDeleteMaterialClick(e)}>
                          <Delete />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    {index === masterStructureMaterials.length - 1 ? null : <Divider />}
                  </React.Fragment>
                );
              })}
            </List>

            {GetViewMode() ? null : GetEmpty(masterStructureMaterials) ?
              <Typography style={{ fontSize: "0.66rem", color: "#f44336", position: "absolute", bottom: -4 + (32 * masterStructureMaterials.length), left: 0 }}>{"Materials - Material list empty"}</Typography>
              : null}
            <Typography style={{ position: "absolute", top: 0, left: 430 + compareToOffset }}>{"Compare to:"}</Typography>

            {/* Spinner Overlay */}
            {isChecking && (
              <Backdrop open={true} style={{ zIndex: 9999, color: '#fff' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress color="inherit" />
                <div style={{ marginLeft: 16 }}>
                  <span style={{ display: "block", marginTop: 8 }}>
                    Checking for enlisted Materials if available in PDM or not...
                  </span>
                  {currentMaterial && (
                    <span style={{ display: "block", marginTop: 8, fontWeight: "bold" }}>
                      {currentMaterial}
                    </span>
                  )}
                </div>
              </div>
            </Backdrop>
            
            )}
            {/* New "+ Import from file" buttons */}
            <div style={{ position: "absolute", top: 0, left: 430 + compareToOffset }}>
                <Button 
                  disabled={GetViewMode()}
                  variant="contained"
                  className={clsx(classes.testCasesButton, globalClasses.blueButton, classes.addCaseButton)}
                  style={{
                    left: 190 + compareToOffset,
                    padding:"2px",
                    paddingLeft:"12px",
                    paddingRight:"12px",
                    }}
onClick={() => document.getElementById("file-input-2").click()}  // Trigger the hidden file input click
                >
                  <AddIcon className={classes.addIcon} /> Import from file
                </Button>
                {/* Hidden File Input */}
                <input
                  id="file-input-2"
                  type="file"
                  style={{ display: "none" }}  // Hide the file input
                  accept=".txt"
                  onChange={handleImportFromFile2}  // Trigger the function when a file is selected
                />
              </div>
              <Dialog
                open={openErrorDialog}
                onClose={() => setOpenErrorDialog(false)}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle style={{ color: '#f44336' }}>
                  Materials Not Found in PDM
                </DialogTitle>
                <DialogContent dividers style={{ maxHeight: 400, overflowY: "auto" }}>
                  <Typography variant="body2" gutterBottom>
                    The following materials were not found in PDM and were not added:
                  </Typography>
                  <List dense>
                    {invalidItemsList.map((item, index) => (
                      <ListItem key={index}>
                        <Typography variant="body2" style={{ wordBreak: "break-all" }}>
                          {item}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenErrorDialog(false)} color="primary">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            <Tooltip title={"Add material"} PopperProps={{ style: { marginLeft: 815 + compareToOffset } }} TransitionComponent={({ children }) => children}>
              <span>

                <IconButton disabled={GetViewMode()} style={{ position: "absolute", top: 0, left: 815 + compareToOffset, width: 24, height: 24, borderRadius: 4 }} className={clsx(classes.generateIdButton, globalClasses.blueButton)} onClick={() => {
                  setCurrentMatDialog(2);
                  setAddMaterialDialog(true);
                  setNewMaterial("");
                }}>
                  <Add />
                </IconButton>
              </span>
            </Tooltip>
            <List style={{ minWidth: "430px", marginTop: "1%", minHeight: '10px', marginBottom: "12px", left: compareToOffset, maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin', boxSizing: "content-box" }} className={clsx("listFix",!GetEmpty(masterStructureCompareToMaterials) && globalClasses.addBorder, (GetEmpty(masterStructureCompareToMaterials) && !GetViewMode()) && globalClasses.errorBorder)}>
              {masterStructureCompareToMaterials.map((e, index) => {
                const isMatch = masterStructureMaterials.includes(e);

                return (
                  <React.Fragment key={"Materials2" + e + index}>
                    <ListItem classes={{ root: classes.item }} style={{ backgroundColor: isMatch ? "#ffcccc" : "transparent" }}>
                    <IconButton disabled={GetViewMode()} aria-label="Up" className={globalClasses.customButton} onClick={() => handleUpClick(e, "materials2")}>
                          <KeyboardArrowUp />
                        </IconButton>
                    <IconButton disabled={GetViewMode()} aria-label="Down" className={globalClasses.customButton} onClick={() => handleDownClick(e, "materials2")}>
                          <KeyboardArrowDown />
                        </IconButton>
                      <ListItemText
                        primary={<EditableTypography
                          value={masterStructureCompareToMaterials[index]}
                          index={index}
                          isViewMode={GetViewMode()}
                          classes={classes}
                          globalClasses={globalClasses}
                          required={true}
                          onChange={(i, val) =>
                            updateByIndex(setMasterStructureCompareToMaterials, i, val)
                          }
                          asyncError={asyncErrors[`masterStructureCompareToMaterials-${index}`] || false}
                          validateAsync={(val) => validateName(val, `masterStructureCompareToMaterials-${index}`)}
                        />}
                      />
                      <ListItemSecondaryAction>
                        <IconButton disabled={GetViewMode()} edge="end" aria-label="delete" className={globalClasses.customButton} onClick={handleDeleteMaterial2Click(e)}>
                          <Delete />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    {index === masterStructureCompareToMaterials.length - 1 ? null : <Divider />}
                  </React.Fragment>
                );
              })}
            </List>
            {GetViewMode() ? null : GetEmpty(masterStructureCompareToMaterials) ?
              <Typography style={{ fontSize: "0.66rem", color: "#f44336", position: "absolute", bottom: -4 + (32 * masterStructureCompareToMaterials.length), left: 430 + compareToOffset }}>{"Compare To - Material list empty"}</Typography>

              : null}
          </div>
        </Paper>
      </TabPanel>
      {/* CONFIGURATION STRUCTURE */}
      <TabPanel value={tabValue} index={1}>
        <Paper style={{ maxHeight: "70vh", paddingBottom: "8px" }}>
          <div className={classes.dvDiv} style={{ paddingTop: "4px", paddingBottom: "4px" }}>
            <Typography className={classes.testInfoItem}>Name:</Typography>
            {/* <Tooltip title={testName} TransitionComponent={({ children }) => children}>
                        <TextField id="outlined-basic" defaultValue={testName} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoName)} />
                    </Tooltip> */}

            <Tooltip title={""} TransitionComponent={({ children }) => children}>
              <TextField disabled error={GetStringEmpty(compareName)} helperText={GetStringEmpty(compareName) ? "Missing BOM Compare name" : ""} FormHelperTextProps={{
                className: globalClasses.helperText
              }} InputProps={{ classes: { input: classes.inputStyle } }} id="outlined-basic" value={compareName} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoID)} onChange={(e) => { setCompareName(e.target.value); }} />
            </Tooltip>

            <Tooltip title={"Generate ID"}>
              <span>

                <Button disabled={GetViewMode()} size="small" className={clsx(classes.generateIdButton, globalClasses.blueButton, GetViewMode() && globalClasses.disabledButton)} onClick={() => {
                  if (compareName == "") {
                    CallFetchCompareId();
                  }
                }} >

                  <Refresh />
                </Button>
              </span>
            </Tooltip>

            <Typography className={classes.testInfoItem} style={{ paddingLeft: "14px" }}>Description:</Typography>
            <Tooltip title={""} TransitionComponent={({ children }) => children}>
              <TextField disabled={GetViewMode()} error={GetStringEmpty(compareDesc)} helperText={GetStringEmpty(compareDesc) ? "Missing BOM Compare description" : ""} FormHelperTextProps={{
                className: clsx(globalClasses.helperText, classes.helperTextOffset)
              }} id="outlined-basic" InputProps={{ classes: { input: classes.inputStyle } }} value={compareDesc} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoDesc)} onChange={(e) => { setCompareDesc(e.target.value); }} />
            </Tooltip>
            {/* <Typography>{"Run BOM Comparison for Configuration structure"}</Typography> */}
            <Tooltip title={"Run BOM Comparison"} TransitionComponent={({ children }) => children}>
              <span>
                <IconButton disabled={GetRunDisabled() || GetViewMode()} style={{ marginLeft: "auto", marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton, (GetRunDisabled() || GetViewMode()) && globalClasses.disabledButton)} onClick={(e) => {
                  handleRunClick(e, "Configuration Structure");
                }}>
                  <PlayArrow />
                </IconButton>
              </span>
            </Tooltip>
          </div>
          
          <div className={classes.dvDiv} style={{ paddingTop: "8px"}}>
            <Typography style={{ fontWeight: "bold" }}>{"Select Structure:"}</Typography>
          </div>
          <div className={classes.dvDiv} style={{ paddingTop: "4px", alignItems: "flex-start", position: "relative" }}>
            <FormGroup row aria-label="structure" style={{ gap: 8 }}>
              <FormControlLabel
                style={{ marginLeft: 0 }}
                control={
                  GetViewMode()
                    ? <CustomRadioDisabled
                        style={{ marginRight: "8px" }}
                        checked={selectedStructures.includes("eng")}
                        onClick={() => toggleStructure("eng")}
                        className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)}
                      />
                    : <CustomRadio
                        style={{ marginRight: "8px" }}
                        checked={selectedStructures.includes("eng")}
                        onClick={() => toggleStructure("eng")}
                        className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)}
                      />
                }
                label="OB Engineering Structure"
                labelPlacement="end"
                disabled={GetViewMode()}
              />

              <FormControlLabel
                style={{ marginLeft: "8px" }}
                control={
                  GetViewMode()
                    ? <CustomRadioDisabled
                        style={{ marginRight: "8px" }}
                        checked={selectedStructures.includes("del")}
                        onClick={() => toggleStructure("del")}
                        className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)}
                      />
                    : <CustomRadio
                        style={{ marginRight: "8px" }}
                        checked={selectedStructures.includes("del")}
                        onClick={() => toggleStructure("del")}
                        className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)}
                      />
                }
                label="OB Delivery Structure"
                labelPlacement="end"
                disabled={GetViewMode()}
              />
            </FormGroup>
          </div>
          
          <div className={classes.dvDiv} style={{ paddingTop: "4px"}}>
            <Typography style={{ fontWeight: "bold" }}>{"Select Method:"}</Typography>
          </div>
          <div className={classes.dvDiv} style={{ paddingTop: "4px", alignItems: "flex-start", position: "relative" }}>
          <RadioGroup row aria-label="onetoone" name="onetoone" value={oneToOne.toString()} onChange={handleOneToOneRadio}>
                    <FormControlLabel
                      style={{ marginLeft: 0 }}
                      value="false"
                      control={
                        GetViewMode() ?
                          <CustomRadioDisabled style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />
                          :
                          <CustomRadio style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />}
                      label="ALL to ALL"
                      labelPlacement="end"
                      disabled={GetViewMode()}
                    />
                    <FormControlLabel
                      style={{ marginLeft: "86px" }}
                      value="true"
                      control={
                        GetViewMode() ?
                          <CustomRadioDisabled style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />
                          :
                          <CustomRadio style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />}
                      label="ONE to ONE"
                      labelPlacement="end"
                      disabled={GetViewMode()}
                    />
                  </RadioGroup>
          </div>

          <div className={classes.dvDiv} style={{ paddingTop: "40px", alignItems: "flex-start", position: "relative" }}>
            <Typography style={{ position: "absolute", top: 4, left: 0 }}>{"Configurations:"}</Typography>
            <Tooltip title={"Add configurations"}PopperProps={{ style: { marginLeft: 650 } }} TransitionComponent={({ children }) => children}>
              <span>

                <IconButton disabled={GetViewMode()} style={{ position: "absolute", top: 0, left: 380, width: 24, height: 24, borderRadius: 4 }} className={clsx(classes.generateIdButton, globalClasses.blueButton)} onClick={() => {
                  setAddConfigurationDialog(true);
                  setTestCaseSearch("");
                  filteredConfigurations.length = 0;
                }}>
                  <Add />
                </IconButton>
              </span>
            </Tooltip>
            <List style={{ minWidth: "430px", minHeight: '30px', marginBottom: "12px" }} className={clsx(!GetEmpty(configurationArray) && globalClasses.addBorder, (GetEmpty(configurationArray) && !GetViewMode()) && globalClasses.errorBorder)}>
              {configurationArray.map((e, index) => {
                return (
                  <React.Fragment key={"Configurations" + e + index}>
                    <ListItem classes={{ root: classes.item }}>
                    <IconButton disabled={GetViewMode()} aria-label="Up" className={globalClasses.customButton} onClick={() => handleUpClick(e, "configurations")}>
                          <KeyboardArrowUp />
                        </IconButton>
                    <IconButton disabled={GetViewMode()} aria-label="Down" className={globalClasses.customButton} onClick={() => handleDownClick(e, "configurations")}>
                          <KeyboardArrowDown />
                        </IconButton>
                      <ListItemText
                        primary={<Typography className={globalClasses.smallFont}>{e}</Typography>}
                      />
                      <ListItemSecondaryAction>
                        <IconButton disabled={GetViewMode()} edge="end" aria-label="delete" className={globalClasses.customButton} onClick={handleDeleteConfigurationClick(e)}>
                          <Delete />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    {index == configurationArray.length - 1 ? null : <Divider />}
                  </React.Fragment>
                );
              })
              }
            </List>
            {GetViewMode() ? null : GetEmpty(configurationArray) ?
              <Typography style={{ fontSize: "0.66rem", color: "#f44336", position: "absolute", bottom: -4 + (32 * comparetoArray.length), left: 0 }}>{"Configuration list empty"}</Typography>
              : null}

            <Typography style={{ position: "absolute", top: 4, left: 430 + compareToOffset }}>{"Compare to:"}</Typography>
            <Tooltip title={"Add compare to"} PopperProps={{ style: { marginLeft: 850 } }} TransitionComponent={({ children }) => children}>
              <span>

                <IconButton disabled={GetViewMode()} style={{ position: "absolute", top: 0, left: 825 + compareToOffset, width: 24, height: 24, borderRadius: 4 }} className={clsx(classes.generateIdButton, globalClasses.blueButton)} onClick={() => {
                  setAddComparetoDialog(true);
                  setTestCaseSearch("");
                  filteredConfigurations.length = 0;
                }}>
                  <Add />
                </IconButton>
              </span>
            </Tooltip>
            <List style={{ minWidth: "430px", minHeight: '30px', marginBottom: "12px", left: compareToOffset }} className={clsx(!GetEmpty(comparetoArray) && globalClasses.addBorder, (GetEmpty(comparetoArray) && !GetViewMode()) && globalClasses.errorBorder)}>
              {comparetoArray.map((e, index) => {
                return (
                  <React.Fragment key={"Compare to" + e + index}>
                    <ListItem classes={{ root: classes.item }}>
                    <IconButton disabled={GetViewMode()} aria-label="Up" className={globalClasses.customButton} onClick={() => handleUpClick(e, "compareto")}>
                          <KeyboardArrowUp />
                        </IconButton>
                    <IconButton disabled={GetViewMode()} aria-label="Down" className={globalClasses.customButton} onClick={() => handleDownClick(e, "compareto")}>
                          <KeyboardArrowDown />
                        </IconButton>
                      <ListItemText
                        primary={<Typography className={globalClasses.smallFont}>{e}</Typography>}
                      />
                      <ListItemSecondaryAction>
                        <IconButton disabled={GetViewMode()} edge="end" aria-label="delete" className={globalClasses.customButton} onClick={handleDeleteConfigurationClick2(e)}>
                          <Delete />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    {index == comparetoArray.length - 1 ? null : <Divider />}
                  </React.Fragment>
                );
              })
              }
            </List>
            {GetViewMode() ? null : GetEmpty(comparetoArray) ?
              <Typography style={{ fontSize: "0.66rem", color: "#f44336", position: "absolute", bottom: -4 + (32 * configurationArray.length), left: 430 + compareToOffset }}>{"Configuration list empty"}</Typography>
              : null}

          </div>

        </Paper>
      </TabPanel>

      {/* PDM CAD COMPARISON */}
      <TabPanel value={tabValue} index={2}>
        <Paper style={{ maxHeight: "70vh" }}>
          {/* <div className={classes.dvDiv} style={{ paddingTop: "4px", paddingBottom: "4px" }}> */}
          {/* <Typography>{"Run PDM CAD Comparison"}</Typography> */}
          <div className={classes.dvDiv} style={{ paddingTop: "4px", paddingBottom: "4px" }}>
            <Typography className={classes.testInfoItem}>Name:</Typography>
            {/* <Tooltip title={testName} TransitionComponent={({ children }) => children}>
                        <TextField id="outlined-basic" defaultValue={testName} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoName)} />
                    </Tooltip> */}

            <Tooltip title={""} TransitionComponent={({ children }) => children}>
              <TextField disabled error={GetStringEmpty(compareName)} helperText={GetStringEmpty(compareName) ? "Missing BOM Compare name" : ""} FormHelperTextProps={{
                className: globalClasses.helperText
              }} InputProps={{ classes: { input: classes.inputStyle } }} id="outlined-basic" value={compareName} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoID)} onChange={(e) => { setCompareName(e.target.value); }} />
            </Tooltip>

            <Tooltip title={"Generate ID"}>
              <span>

                <Button disabled={GetViewMode()} size="small" className={clsx(classes.generateIdButton, globalClasses.blueButton, GetViewMode() && globalClasses.disabledButton)} onClick={() => {
                  if (compareName == "") {
                    CallFetchCompareId();
                  }
                }} >

                  <Refresh />
                </Button>
              </span>
            </Tooltip>

            <Typography className={classes.testInfoItem} style={{ paddingLeft: "14px" }}>Description:</Typography>
            <Tooltip title={""} TransitionComponent={({ children }) => children}>
              <TextField disabled={GetViewMode()} error={GetStringEmpty(compareDesc)} helperText={GetStringEmpty(compareDesc) ? "Missing BOM Compare description" : ""} FormHelperTextProps={{
                className: globalClasses.helperText
              }} id="outlined-basic" InputProps={{ classes: { input: classes.inputStyle } }} value={compareDesc} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoDesc)} onChange={(e) => { setCompareDesc(e.target.value); }} />
            </Tooltip>
            <Tooltip title={"Run PDM CAD Comparison"} TransitionComponent={({ children }) => children}>
              <span>
                <IconButton disabled={GetRunDisabled()} style={{ marginLeft: "auto", marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton, GetRunDisabled() && globalClasses.disabledButton)} onClick={(e) => {
                  handleRunClick(e, "PDM CAD Comparison");
                }}>
                  <PlayArrow />
                </IconButton>
              </span>
            </Tooltip>
            {/* </div> */}
          </div>

          <div className={classes.dvDiv} style={{ paddingTop: "8px", paddingBottom: "8px" }}>
            <Typography style={{whiteSpace: "nowrap"}}>{"Test order: "}</Typography>
            <Autocomplete
              id="testCaseSearch"
              size="small"
              classes={{ input: classes.inputStyle }}
              style={{ width: "350px", marginLeft: "4px", marginRight: "8px" }}
              clearOnBlur
              selectOnFocus
              onChange={(e, value) => {
                handleTestOrderSearch("");
                setTestCaseSearch("");
                handleSetConfigurationList(value["orderName"]);
                setSearchValue(value);
              }}
              getOptionLabel={(option) => option ? option["orderName"] : ""}
              loading={loadingBatches}
              renderOption={(option, index) =>
                loadingBatches ?
                  <CircularProgress></CircularProgress>
                  :
                  option
                    ?
                    <MenuItem disabled={GetViewMode()} key={"CaseSearch" + option["orderName"] + index}
                      onClick={(e) => {
                        setShowConfigRadio(true);
                        handleSetConfigurationList(option["orderName"]);
                      }}>
                      {/* <Typography>{filteredName["orderName"]}</Typography> */}
                      {
                        <ListItemText
                          style={{ margin: "0", overflow: "ellipsis" }}
                          disableTypography
                          primary={<Typography className={globalClasses.smallFont}>{option["orderName"]}{option["description"] ? ", " + option["description"] : ""}</Typography>}
                          secondary={
                            <Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)" }}>{option["material"] + "/" + option["materialRevision"] + ", Last run: " + ConvertedTimeString(option["lastRun"])}</Typography>
                          }
                        />
                      }
                    </MenuItem>
                    :
                    <></>
              }
              filterOptions={(options) => options}
              options={
                filteredOrders
              }
              renderInput={(params) => (
                <TextField {...params} 
                error={GetEmpty(searchValue) && !GetViewMode()} 
                helperText={GetViewMode() ? "" : GetEmpty(searchValue) ? "Missing test order" : ""} 
                FormHelperTextProps={{
                  className: globalClasses.helperText
                }}
                onChange={(e) => {
                  handleTestOrderSearch(e.target.value);
                }}
                  id="outlined-basic" variant="outlined" onFocus={() => {
                    if (submitTestCaseSearch == "") {
                      handleTestOrderSearch("");
                    }
                  }} 
                  onBlur={() => {
                    handleTestOrderSearch("");
                    setTestCaseSearch("");
                  }}
                  InputLabelProps={{ shrink: true }} />
              )}
            />
          </div>

          <div className={classes.dvDiv} style={{ paddingTop: "8px", paddingBottom: "8px" }}>
            {
              showConfigRadio ?
                <div className={classes.dvDiv} style={{ marginLeft: "0px" }}>
                  <RadioGroup aria-label="position" name="position" value={pdmCADValue} onChange={handlePDMCadValue}>
                    <FormControlLabel
                      style={{ marginLeft: 0 }}
                      value="useLatestPDM"
                      control={
                        GetViewMode() ?
                          <CustomRadioDisabled style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />
                          :
                          <CustomRadio style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />}
                      label="Use latest"
                      labelPlacement="start"
                      disabled={GetViewMode()}
                    />
                    <FormControlLabel
                      style={{ marginLeft: "8px" }}
                      value="toConfigPDM"
                      control={
                        GetViewMode() ?
                          <CustomRadioDisabled style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />
                          :
                          <CustomRadio style={{ marginRight: "8px" }} className={clsx(globalClasses.checkbox, GetViewMode() && globalClasses.grayColor, !GetViewMode() && globalClasses.blueColor)} />}
                      label="To configuration"
                      labelPlacement="start"
                      disabled={GetViewMode()}
                    />
                  </RadioGroup>
                  {
                    // pdmCADValue == "toConfigPDM" ?
                    <>
                  <div style={{ paddingTop: "22px", paddingLeft: "8px" }}>
                  <Tooltip title={pdmCADValue === "useLatestPDM" ? latestConfig : pdmCADConfig}>
        <TextField
            disabled={pdmCADValue !== "toConfigPDM" || GetViewMode()}
            value={pdmCADValue === "useLatestPDM" ? latestConfig : pdmCADConfig}
            id="outlined-multiline-static"
            maxRows={4}
            multiline
            variant="outlined"
            style={{
                paddingBottom: "1px",
                marginLeft: "16px",
                width: "370px",
                boxSizing: "border-box",
            }}
            InputProps={{
                notched: false,
                style: {
                    overflowY: 'auto', 
                    padding: "8px", 
                    height: "calc(100% - 16px)", 
                }
            }}
            InputLabelProps={{
                shrink: true,
                classes: {
                    root: globalClasses.inputLabel,
                    shrink: "shrink"
                }
            }}
            className={clsx(classes.multilineField, {
                [classes.lockedTextField]: pdmCADValue !== "toConfigPDM",
            })}
        />
        </Tooltip>

           <IconButton disabled={GetViewMode()} style={{ marginLeft: "8px", width: 34, height: 29, borderRadius: 4 }} className={clsx(globalClasses.blueButton)} onClick={() => {
                          setAddPDMCADDialog(true);
                          setTestCaseSearch("");
                        }}>
                          <Search />
                        </IconButton>
                      </div>
                      {/* <TextField value={""} type="number" error={customLevelValue.toString() == ""} InputProps={{ classes: { input: classes.inputStyle } }} style={{ paddingTop: "42px", paddingLeft: "8px", width: "80px" }} id="outlined-basic" variant="outlined" size="small" ></TextField>
                  <FormHelperText style={{ paddingLeft: "8px", paddingTop: "42px" }} hidden={!(customLevelValue.toString() == "")} error={customLevelValue.toString() == ""} id="component-error-text">{"Custom sublevel must contain a value!"}</FormHelperText> */}
                    </>
                    // : null
                  }

                </div>
                : null
            }

            <Dialog disableRestoreFocus onClose={() => setAddPDMCADDialog(false)} open={addPDMCADDialog} fullWidth={true} maxWidth="sm" classes={{ paper: classes.dialogPaper, scrollPaper: classes.topScrollPaper, paperScrollBody: classes.topPaperScrollBody }}>
              <DialogContent style={{ padding: "12px 18px" }}>
                <div className={globalClasses.containerDiv}>
                  <Typography style={{whiteSpace: "nowrap"}}>{"Test order: "}</Typography>
                  <TextField
                  value={GetEmpty(searchValue) ? "" : searchValue["orderName"]}
                  disabled
                  onChange={(e) => {
                    setTestCaseElAnchor(e.target);
                    setTestCaseSearch(e.target.value);
                  }}
                  InputProps={{
                    classes: { input: classes.inputStyle, adornedEnd: classes.endAdornment }
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  style={{ paddingTop: "0px", paddingLeft: "8px", maxWidth: "100%" }}
                />

                  <Tooltip title={"Cancel"} TransitionComponent={({ children }) => children}>
                    <IconButton style={{ marginLeft: "auto", marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton)} onClick={() => {
                      setAddPDMCADDialog(false);
                      console.log("row 858");

                    }}>
                      <Cancel />
                    </IconButton>
                  </Tooltip>
                </div>

                <Typography style={{ paddingTop: "8px" }}>{filteredConfigurations.length == 0 ? " " : "Configurations"}</Typography>
                <List>
                  {filteredConfigurations.sort((conf1, conf2) => new Date(conf1["lastRun"]).valueOf() - new Date(conf2["lastRun"]).valueOf()).reverse().map((confobj, index) => {
                    return (
                      <ListItem style={{ padding: "0" }} key={confobj + index} button onClick={handleConfigClickPDMCAD(confobj)}>
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText
                          primary={<Typography>{confobj.name}</Typography>}
                          secondary={<Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)" }}>{ConvertedTimeString(confobj.lastRun)}</Typography>}
                        ></ListItemText>
                      </ListItem>
                    );
                  })}
                </List>
              </DialogContent>
            </Dialog>

          </div>
        </Paper>
      </TabPanel>

      <Dialog disableRestoreFocus onClose={() => setAddMaterialDialog(false)} open={addMaterialDialog} fullWidth={true} maxWidth="sm" classes={{ paper: classes.dialogPaper, scrollPaper: classes.topScrollPaper, paperScrollBody: classes.topPaperScrollBody }}>
        <DialogContent style={{ padding: "12px 18px" }}>
          <div className={globalClasses.containerDiv}>
            <Typography style={{ whiteSpace: "nowrap", paddingRight: "8px"}}>{"Material: "}</Typography>
            <Tooltip title={""} TransitionComponent={({ children }) => children}>
              <TextField id="outlined-basic" InputProps={{ classes: { input: classes.inputStyle } }} value={newMaterial} variant="outlined" size="small" className={clsx(classes.textField, classes.testInfoItem, classes.testInfoDesc)} 
                onChange={(e) => { setNewMaterial(e.target.value); }} 
                onKeyUp={(e) => {
                    convertToUppercase(e);
                }}
                onBlur={(e) => {
                    convertSpaceToTrimmed(e);
                }}
                onKeyPress={handleKeyPress} />              
            </Tooltip>
            <Tooltip title={"Cancel"} TransitionComponent={({ children }) => children}>
              <IconButton style={{ marginLeft: "auto", marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton)} onClick={() => {
                setAddMaterialDialog(false);
              }}>
                <Cancel />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Confirm"} TransitionComponent={({ children }) => children}>
              <IconButton style={{ marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton)} onClick={() => {
                handleAddMaterialConfirmClick();
              }}>
                <Check />
              </IconButton>
            </Tooltip>
          </div>

        </DialogContent>
      </Dialog>

      <Dialog disableRestoreFocus onClose={() => setAddConfigurationDialog(false)} open={addConfigurationDialog} fullWidth={true} maxWidth="sm" classes={{ paper: classes.dialogPaper, scrollPaper: classes.topScrollPaper, paperScrollBody: classes.topPaperScrollBody }}>
        <DialogContent style={{ padding: "12px 18px" }}>
          <div className={globalClasses.containerDiv}>
            <Typography style={{ whiteSpace: "nowrap"}}>{"Test order: "}</Typography>
            <Autocomplete
              id="testCaseSearch3"
              size="small"
              classes={{ input: classes.inputStyle }}
              style={{ width: "100%", marginLeft: "4px", marginRight: "8px" }}
              clearOnBlur
              selectOnFocus
              onChange={(e, option) => {
                handleTestOrderSearch("");
                setTestCaseSearch("");
                setShowConfigRadio(true);
                handleSetConfiguration(option["orderName"]);
              }}
              getOptionLabel={(option) => option ? option["orderName"] : ""}
              loading={loadingBatches}
              filterOptions={(options) => options}
              renderOption={(option, index) =>
                loadingBatches ?
                  <CircularProgress></CircularProgress>
                  :
                  option
                    ?
                    <MenuItem disabled={GetViewMode()} key={"CaseSearch" + option["orderName"] + index}
                      onClick={(e) => {
                        setShowConfigRadio(true);
                        handleSetConfiguration(option["orderName"]);
                      }}>
                      {/* <Typography>{filteredName["orderName"]}</Typography> */}
                      {
                        <ListItemText
                          style={{ margin: "0", paddingLeft: "2px", overflow: "ellipsis" }}
                          disableTypography
                          primary={<Typography className={globalClasses.smallFont}>{option["orderName"]}{option["description"] ? ", " + option["description"] : ""}</Typography>}
                          secondary={
                            <Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)" }}>{option["material"] + "/" + option["materialRevision"] + ", Last run: " + ConvertedTimeString(option["lastRun"])}</Typography>
                          }
                        />
                      }
                    </MenuItem>
                    :
                    <></>
              }
              options={
                filteredOrders
              }
              renderInput={(params) => (
                <TextField {...params} FormHelperTextProps={{
                  className: globalClasses.helperText
                }} onChange={(e) => {
                  handleTestOrderSearch(e.target.value);
                  setTestCaseSearch(e.target.value)
                }}
                  id="outlined-basic" variant="outlined" onFocus={() => {
                    if (submitTestCaseSearch == "") {
                      handleTestOrderSearch("");
                    }
                  }} 
                  onBlur={() => {
                    handleTestOrderSearch("");
                    setTestCaseSearch("");
                  }}
                  InputLabelProps={{ shrink: true }} />
              )}
            />

            <Tooltip title={"Cancel"} TransitionComponent={({ children }) => children}>
              <IconButton style={{ marginLeft: "auto", marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton)} onClick={() => {
                setAddConfigurationDialog(false);
              }}>
                <Cancel />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Confirm"} TransitionComponent={({ children }) => children}>
              <IconButton style={{ marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton)} onClick={() => {
                handleConfigurationConfirmClick();
              }}>
                <Check />
              </IconButton>
            </Tooltip>
          </div>

          <Typography style={{ paddingTop: "8px" }}>{filteredConfigurations.length == 0 ? " " : "Configurations"}</Typography>
          <List>
            {filteredConfigurations.sort((conf1, conf2) => new Date(conf1["lastRun"]).valueOf() - new Date(conf2["lastRun"]).valueOf()).reverse().map((confobj, index) => {
              return (
                <ListItem style={{ padding: "0" }} key={confobj + index} button onClick={handleConfigClick(confobj)}>
                  <ListItemIcon>
                    <Checkbox
                      style={{ color: "#0071B9" }}
                      className={classes.checkbox}
                      checked={selectedConfigurations.indexOf(confobj) !== -1}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>{confobj.name}</Typography>}
                    secondary={<Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)" }}>{ConvertedTimeString(confobj.lastRun)}</Typography>}
                  ></ListItemText>
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
      </Dialog>


      <Dialog disableRestoreFocus onClose={() => setAddComparetoDialog(false)} open={addComparetoDialog} fullWidth={true} maxWidth="sm" classes={{ paper: classes.dialogPaper, scrollPaper: classes.topScrollPaper, paperScrollBody: classes.topPaperScrollBody }}>
        <DialogContent style={{ padding: "12px 18px" }}>
          <div className={globalClasses.containerDiv}>
            <Typography style={{whiteSpace: "nowrap"}}>{"Test order: "}</Typography>
            <Autocomplete
              id="testCaseSearch4"
              size="small"
              classes={{ input: classes.inputStyle }}
              style={{ width: "450px", marginLeft: "4px", marginRight: "8px" }}
              clearOnBlur
              selectOnFocus
              onChange={(e, option) => {
                handleTestOrderSearch("");
                setTestCaseSearch("");
                setShowConfigRadio(true);
                handleSetConfiguration(option["orderName"]);
              }}
              getOptionLabel={(option) => option ? option["orderName"] : ""}
              loading={loadingBatches}
              filterOptions={(options) => options}
              renderOption={(option, index) =>
                loadingBatches ?
                  <CircularProgress></CircularProgress>
                  :
                  option
                    ?
                    <MenuItem disabled={GetViewMode()} key={"CaseSearch" + option["orderName"] + index}
                      onClick={(e) => {
                        setShowConfigRadio(true);
                        handleSetConfiguration(option["orderName"]);
                      }}>
                      {/* <Typography>{filteredName["orderName"]}</Typography> */}
                      {
                        <ListItemText
                          style={{ margin: "0", paddingLeft: "2px", overflow: "ellipsis" }}
                          disableTypography
                          primary={<Typography className={globalClasses.smallFont}>{option["orderName"]}{option["description"] ? ", " + option["description"] : ""}</Typography>}
                          secondary={
                            <Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)" }}>{option["material"] + "/" + option["materialRevision"] + ", Last run: " + ConvertedTimeString(option["lastRun"])}</Typography>
                          }
                        />
                      }
                    </MenuItem>
                    :
                    <></>
              }
              options={
                filteredOrders
              }
              renderInput={(params) => (
                <TextField {...params} FormHelperTextProps={{
                  className: globalClasses.helperText
                }} onChange={(e) => {
                  handleTestOrderSearch(e.target.value);
                  setTestCaseSearch(e.target.value)
                }}
                  id="outlined-basic" variant="outlined" onFocus={() => {
                    if (submitTestCaseSearch == "") {
                      handleTestOrderSearch("");
                    }
                  }} 
                  onBlur={() => {
                    handleTestOrderSearch("");
                    setTestCaseSearch("");
                  }}
                  InputLabelProps={{ shrink: true }} />
              )}
            />

            <Tooltip title={"Cancel"} TransitionComponent={({ children }) => children}>
              <IconButton style={{ marginLeft: "auto", marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton)} onClick={() => {
                setAddComparetoDialog(false);
              }}>
                <Cancel />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Confirm"} TransitionComponent={({ children }) => children}>
              <IconButton style={{ marginRight: "8px", marginTop: "0px" }} className={clsx(globalClasses.blueButton)} onClick={() => {
                handleComparetoConfirmClick();
              }}>
                <Check />
              </IconButton>
            </Tooltip>
          </div>

          <Typography style={{ paddingTop: "8px" }}>{filteredConfigurations.length == 0 ? " " : "Configurations"}</Typography>
          <List>
            {filteredConfigurations.map((confobj, index) => {
              return (
                <ListItem style={{ padding: "0" }} key={confobj + index} button onClick={handleComparetoClick(confobj)}>
                  <ListItemIcon>
                    <Checkbox
                      style={{ color: "#0071B9" }}
                      className={classes.checkbox}
                      checked={selectedComparetos.indexOf(confobj) !== -1}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>{confobj.name}</Typography>}
                    secondary={<Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)" }}>{ConvertedTimeString(confobj.lastRun)}</Typography>}
                  ></ListItemText>
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
      </Dialog>

      <ModalPopup
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          title="PDM Sign in"
          instance={instance}
          accounts={accounts}
          setPdmUsername={setPdmUsername}
          onResolve={modalResolveRef.current}
      />
    </>
  );
}